<template>
    <div>
        <div class="btn-box" style="margin-bottom: 20px;">
            <el-button size="small" type="primary" @click="handleClickCreateTaxRate()">创建税率模板</el-button>
        </div>
        <el-table :data="datalist" fit>
            <el-table-column prop="id" label="id" width="100px" />
            <el-table-column prop="name" label="名称" width="185px" />
            <el-table-column label="佣金率">
                <template slot-scope="scope">
                    <div class="rate-box">
                        <span>{{ forMatterRate(scope.row.rate) }}</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="create_time" label="更新时间" />
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <div class="edit-btn-box">
                        <el-button size="mini" type="primary" @click="handleUpdateTaxRate(scope.row)">更新</el-button>
                        <el-button size="mini" type="primary" @click="handleGetTaxRateHistory(scope.row)">修改历史</el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <page-bar
            ref="pageBar"
            :pageSize="50"
            :pageSizes="pageSizes"
            :currentPageCount="datalist.length"
            @page-changed="loadData"
        ></page-bar>
        <el-dialog title="设置佣金率模板" :visible.sync="createSettlementRateDialogShow">
            <el-form>
                <el-form-item label="模板名称：" label-width="150px">
                    <el-input v-model="settlementRate.name" style="width: 70%;"></el-input>
                </el-form-item>
                <el-form-item label="税率：" label-width="150px">
                    <div class="box">
                        <el-input v-model="settlementRate.rate" style="width: 70%;margin-right: 20px;"></el-input>
                        <span style="color: red;font-size: 12px;">取值范围1~10000</span>
                    </div>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="createSettlementRateDialogShow = false">取 消</el-button>
                <el-button type="primary" @click="handleCreateOrUpdateRate">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="佣金率修改历史" :visible.sync="historyDialogShow">
            <el-table :data="historyRate">
                <el-table-column prop="id" label="id" width="100px" />
                <el-table-column prop="name" label="名称" width="185px" />
                <el-table-column label="佣金率">
                    <template slot-scope="scope">
                        {{ forMatterRate(scope.row.rate) }}
                    </template>
                </el-table-column>
                <el-table-column prop="create_time" label="更新时间" />
            </el-table>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="historyDialogShow = false">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import request from '@/api/request.js'
import PageBar from '../ui/PageBar'
export default {
    components: {
        PageBar
    },
    data(){
        return {
            pageSizes: [10, 20, 50],
            currentRange: [0, 50],
            datalist: [],
            createSettlementRateDialogShow: false,
            historyDialogShow: false,
            settlementRate: {
                name: '',
                rate: null
            },
            historyRate: [],
            type: 'create'
        }
    },
    created() {
        this.loadData(this.currentRange)
    },
    methods: {
        loadData(range) {
            this.currentRange = range
            request.saas
                .post('settlement/get_tax_rate_template_list', {
                    range: range,
                })
                .then(r => {
                    this.datalist = r.data.list
                })
        },
        handleGetTaxRateHistory(rate){
            //获取修改历史  
            request.saas
                .post('settlement/get_tax_rate_template_history', {
                    id: rate.id,
                })
                .then(r => {
                    console.log(r.data.list)
                    this.historyRate = r.data.list
                    this.historyDialogShow = !this.historyDialogShow
                })
        },
        handleCreateOrUpdateRate(){
            if(this.type === 'create') {
                //创建
                let data = {
                    name: this.settlementRate.name,
                    rate: Number(this.settlementRate.rate)
                }
                request.saas
                    .post('settlement/create_tax_rate_template', data)
                    .then(() => {
                        this.$message.success('创建成功')
                        this.createSettlementRateDialogShow = !this.createSettlementRateDialogShow
                        this.loadData(this.currentRange)
                    })
            } else {
                //更新

                let data = {
                    id: this.settlementRate.id,
                    name: this.settlementRate.name,
                    rate: Number(this.settlementRate.rate)
                }
                request.saas
                    .post('settlement/update_tax_rate_template', data)
                    .then(() => {
                        this.$message.success('更新成功')
                        this.createSettlementRateDialogShow = !this.createSettlementRateDialogShow
                        this.loadData(this.currentRange)
                    })
            }
        },
        handleUpdateTaxRate(item){
            this.type = 'update'
            this.settlementRate = item
            this.createSettlementRateDialogShow = !this.createSettlementRateDialogShow
        },
        handleClickCreateTaxRate(){
            this.type = 'create'
            this.createSettlementRateDialogShow = !this.createSettlementRateDialogShow
        },
        forMatterRate(rate){
            return (rate/100).toFixed(2) + '%'
        }
    }
}
</script>
<style scoped>
.rate-box{
    display: flex;
    flex-direction: row;
    align-items: center;
}
.rate-box span{
    margin-right: 20px;
}
.box{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    flex-wrap: wrap;
}
</style>
